import { Radio } from "lucide-react";

/** Live market digit tape — transparency, not prediction. Every tick is
 * independent; the label says so in plain words. */
const DigitTape = ({ digits, total, marketLabel }) => {
  const shown = digits.slice(-26);
  const startKey = total - shown.length;
  const evens = digits.filter((d) => d % 2 === 0).length;
  const evenPct = digits.length ? Math.round((evens / digits.length) * 100) : 0;

  return (
    <div data-testid="arcade-digit-tape" className="rounded-xl border border-white/10 bg-[#131722] px-4 py-3">
      <style>{`@keyframes tape-in {0%{transform:translateX(10px) scale(.6);opacity:0}100%{transform:translateX(0) scale(1);opacity:1}}`}</style>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="inline-flex items-center gap-1.5 text-[9px] font-mono uppercase tracking-[0.25em] text-white/45 shrink-0">
          <Radio className={`w-3.5 h-3.5 ${digits.length ? "text-[#089981] animate-pulse" : "text-white/25"}`} />
          Live digits · <span data-testid="digit-tape-market">{marketLabel || "V100 1s"}</span>
        </span>
        <div className="flex items-center gap-1 overflow-hidden flex-1 justify-end min-w-0">
          {shown.map((d, i) => (
            <span key={startKey + i}
              data-testid={i === shown.length - 1 ? "digit-chip-latest" : undefined}
              className={`w-5 h-6 rounded flex items-center justify-center text-[11px] font-black font-mono shrink-0 ${d % 2 === 0
                ? "text-[#ff8a95] bg-[#F23645]/15" : "text-[#0be9a8] bg-[#089981]/15"} ${i === shown.length - 1 ? "ring-1 ring-[#F7B731]/70" : ""}`}
              style={i === shown.length - 1 ? { animation: "tape-in .25s ease" } : {}}>
              {d}
            </span>
          ))}
          {shown.length === 0 && <span className="text-[10px] font-mono text-white/30">connecting to market feed…</span>}
        </div>
      </div>
      <div className="flex items-center gap-3 mt-1.5 flex-wrap">
        <p data-testid="digit-tape-stats" className="text-[10px] font-mono text-white/55">
          last {digits.length || 0} ticks: <span className="text-[#ff8a95] font-bold">EVEN {evenPct}%</span> · <span className="text-[#0be9a8] font-bold">ODD {100 - evenPct}%</span>
        </p>
        <p data-testid="digit-tape-legend" className="text-[10px] font-mono">
          <span className="px-1.5 py-0.5 rounded bg-[#F23645]/15 text-[#ff8a95] font-bold">EVEN = 0 2 4 6 8</span>
          <span className="mx-1 text-white/30">·</span>
          <span className="px-1.5 py-0.5 rounded bg-[#089981]/15 text-[#0be9a8] font-bold">ODD = 1 3 5 7 9</span>
        </p>
        <p className="text-[9px] font-mono text-white/35 ml-auto">
          transparency feed — every tick is independent · past digits do NOT predict the next one
        </p>
      </div>
    </div>
  );
};

export default DigitTape;
